import { ScreenBase } from "@frui.ts/screens";
import { interfaces } from "inversify";
import OutageService from "services/outageService";
import { computed } from "mobx";
import LocalizationService from "services/localizationService";
import SystemComponentOutageResponse from "entities/systemComponentOutageResponse";

const OrderOutageNavigationName = "outage";

export default class OrderOutageViewModel extends ScreenBase {
  @computed
  get message() {
    return this.outageService.getMessage(this.outage);
  }

  constructor(
    private outage: SystemComponentOutageResponse,
    private outageService: OutageService,
    private localizationService: LocalizationService
  ) {
    super();
    this.navigationName = OrderOutageNavigationName;
  }

  protected onActivate(): Promise<any> | void {
    document.getElementById("main")?.classList.add("outage");
    return super.onActivate();
  }

  protected onDeactivate(isClosing: boolean): Promise<any> | void {
    document.getElementById("main")?.classList.remove("outage");
    return super.onDeactivate(isClosing);
  }

  translate(code: string) {
    return this.localizationService.translateGeneral(`eshop.orderOutage.${code}`);
  }

  static Factory({ container }: interfaces.Context) {
    return (outage: SystemComponentOutageResponse) => {
      return new OrderOutageViewModel(outage, container.get(OutageService), container.get(LocalizationService));
    };
  }
}
